import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import ErrorMessage from 'components/app/ErrorPage/ErrorMessage';
import SEO from 'components/shared/SEO';
import Heading from 'components/shared/Heading';
import Text from 'components/shared/Text';
import VerifyEmailReturn from './VerifyEmailReturn';
import ResetPasswordReturn from './ResetPasswordReturn';
import RecoverEmail from './RecoverEmail';

const microapps = window.MICROFRONTENDS_CONFIG;

function AccountAction(props) {
  const { t } = useTranslation();
  const [checkingActionCode, setCheckingActionCode] = useState(true);
  const [validActionCode, setValidActionCode] = useState(false);
  const [error, setError] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('mode');
  const actionCode = params.get('oobCode');

  useEffect(() => {
    async function validateActionCode() {
      try {
        if (actionCode) await window.FIREBASE.checkActionCode(actionCode);
        setValidActionCode(true);
      } catch (caughtError) {
        if (
          caughtError.code === 'auth/invalid-action-code' ||
          caughtError.code === 'auth/expired-action-code'
        ) {
          setValidActionCode(false);
        } else {
          setError(true);
        }
      } finally {
        setCheckingActionCode(false);
      }
    }
    validateActionCode();
  }, [actionCode]);

  if (checkingActionCode) {
    return null;
  }

  if (!validActionCode) {
    switch (mode) {
      case 'verifyEmail': {
        return (
          <>
            <SEO title={t('auth_action_verify_meta_title')} />
            <Heading tag="h1">{t('error_title_generic')}</Heading>
            <Text>{t('auth_action_verify_expired')}</Text>
          </>
        );
      }
      case 'resetPassword': {
        return (
          <>
            <SEO title={t('auth_action_password_meta_title')} />
            <Heading tag="h1">{t('error_title_generic')}</Heading>
            <Text>{t('auth_action_password_expired')}</Text>
          </>
        );
      }
      case 'recoverEmail':
        return (
          <>
            <SEO title={t('auth_action_email_meta_title')} />
            <Heading tag="h1">{t('error_title_generic')}</Heading>
            <Text>{t('auth_action_email_expired')}</Text>
          </>
        );
      default:
        return <Redirect to={microapps.routes.login.path} />;
    }
  }

  if (error) {
    return <ErrorMessage />;
  }

  if (!actionCode || !mode) {
    return <Redirect to={microapps.routes.login.path} />;
  }

  switch (mode) {
    case 'verifyEmail':
      return <VerifyEmailReturn {...props} actionCode={actionCode} />;
    case 'resetPassword':
      return <ResetPasswordReturn {...props} actionCode={actionCode} />;
    case 'recoverEmail':
      return <RecoverEmail {...props} actionCode={actionCode} />;
    default:
      return <Redirect to={microapps.routes.login.path} />;
  }
}

AccountAction.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export default AccountAction;
